import { useState } from 'react';
import { DayPicker, type DateRange } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/useMediaQuery';

type Props = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  initial?: DateRange;
  onConfirm: (range: DateRange | undefined) => void;
};

export function DateRangeModal({ open, onOpenChange, initial, onConfirm }: Props) {
  const [range, setRange] = useState<DateRange | undefined>(initial);
  const isMobile = useIsMobile();

  function handleConfirm() {
    onConfirm(range);
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[min(420px,95vw)] md:w-[min(780px,95vw)]">
        <DialogHeader>
          <DialogTitle>Pick your dates</DialogTitle>
          <DialogDescription>Tap a start date, then an end date.</DialogDescription>
        </DialogHeader>

        <div className="uo-rdp-wrap flex justify-center px-3 py-4">
          <DayPicker
            mode="range"
            numberOfMonths={isMobile ? 1 : 2}
            selected={range}
            onSelect={setRange}
            disabled={{ before: new Date() }}
            showOutsideDays={false}
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => setRange(undefined)}>
            Clear
          </Button>
          <Button onClick={handleConfirm} disabled={!range?.from}>
            Confirm dates
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
